import { useT } from '../i18n/index.js';
import { PageHeader } from '../components/PageHeader.js';
import { HardwareSection } from '../features/hardware/HardwareSection.js';
import { FleetSection } from '../features/hardware/FleetSection.js';
import { PackagingSection } from '../features/deploy/PackagingSection.js';

/**
 * Section « Deploy » (PRD NFR-27). Deux volets : le **packaging / déploiement d'un modèle** sur le
 * matériel cible — cadré ADR-0014 (Phase D), pas encore implémenté : on pose l'intention et la
 * distinction honnête entre ce qui *adapte* le modèle (le calcul) et la donnée d'inventaire — et le
 * **Hardware** (catalogue de pièces + nomenclatures, ADR-0030), lui fonctionnel.
 */
export function DeployPage() {
  const t = useT();
  return (
    <section className="ddp-page__section ddp-deploy">
      <PageHeader title={t('deploy.title')} lead={t('deploy.intro')} tourScope="deploy" />

      {/* Liens de section accrochés (ancre vers chaque bloc de la page), comme sur les autres pages. */}
      <nav className="ddp-page-subnav" aria-label={t('deploy.title')}>
        <a href="#deploy-compute">{t('deploy.computeLabel')}</a>
        <a href="#deploy-packaging">{t('deploy.packaging.title')}</a>
        <a href="#deploy-fleet">{t('fleet.title')}</a>
        <a href="#deploy-hardware">{t('deploy.hardwareLabel')}</a>
      </nav>

      <div className="ddp-deploy__soon">
        <span className="ddp-deploy__badge">{t('deploy.soonBadge')}</span>
        <p className="ddp-deploy__lead">{t('deploy.soonLead')}</p>
      </div>

      <div className="ddp-deploy__family">
        <h2 id="deploy-compute" className="ddp-deploy__family-name">
          {t('deploy.computeLabel')}
        </h2>
        <p className="ddp-deploy__family-text">{t('deploy.computeText')}</p>
      </div>

      {/* Packaging (ADR-0034) : empaqueter un modèle validé pour le runtime cible d'un matériel. Dormant. */}
      <PackagingSection anchorId="deploy-packaging" />

      {/* Flotte de matériels (ADR-0029) : ajout et gestion vivent ici ; l'Overview n'en liste qu'un aperçu. */}
      <FleetSection anchorId="deploy-fleet" />

      {/* Sous-partie Hardware : catalogue de pièces + nomenclature (remplace l'ancien bloc « Airframe »). */}
      <HardwareSection />
    </section>
  );
}
